import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  InputNumber,
  Switch,
  Select,
  message,
} from "antd";
import get from "lodash/get";
import find from "lodash/find";
import { connect } from "react-redux";

import {
  imednetUploadGet,
  imednetUploadTest,
  imednetUploadUpdate,
  imednetUploadActivate,
  imednetUploadDeactivate,
} from "../../api/requests";

import classes from "./ImednetScheduleForm.css";
import {
  getApiImednetCreatePermission,
  getApiImednetUpdatePermission,
  getApiImednetDeletePermission,
} from "../../reducers/user/selectors";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const timezones = require("../../utils/timezones.json");

class ImednetScheduleForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingData: true,
      isLoading: false,
      isLoadingTest: false,
      requestResult: {},
      schedule: {},
      test: {},
      shortTz: get(
        find(timezones, ({ utc }) => utc.includes(this.props.time_zone)),
        "abbr",
        ""
      ),
    };
  }

  async componentDidMount() {
    // this.getStatus();

    await this.getSchedule();

    this.setState({ isLoadingData: false });
  }

  async getSchedule() {
    try {
      const { data } = await imednetUploadGet();
      this.setState({ schedule: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  }

  async getStatus() {
    this.setState({ isLoadingTest: true });
    try {
      const { data } = await imednetUploadTest();
      this.setState({ test: data });
    } catch (e) {
      this.setState({ test: { error: get(e, "response.data.error") } });
    }

    this.setState({ isLoadingTest: false });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.props.apiImednetCreatePermission) {
      return;
    }

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        const scheduled = { ...values };

        try {
          await imednetUploadUpdate({ ...scheduled });
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
            test: {},
          });

          this.getStatus();
          this.getSchedule();

          // setTimeout(() => {
          //   this.props.onSubmit(this.props.id);
          // }, 2200);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onSwitchActivation = (state) => async () => {
    this.setState({ isLoading: true });

    try {
      if (state === "active") {
        await imednetUploadDeactivate();
      } else {
        await imednetUploadActivate();
      }

      message.success(this.props.i18n.t("Saved"));

      await this.getSchedule();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
    }

    this.setState({ isLoading: false });
  };

  /*onChangeTimezone = (value) => {
    const shortTz = get(find(timezones, ({ utc }) => utc.includes(value)), 'abbr', '') || [null, null];
    this.props.form.setFieldsValue({'short_tz': shortTz});
  };*/

  render() {
    const {
      isLoading,
      requestResult,
      isLoadingData,
      isLoadingTest,
      test,
      schedule,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      apiImednetCreatePermission,
      apiImednetUpdatePermission,
      apiImednetDeletePermission,
    } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceScheduleUpload1Form:API 1 Push Subject to iMednet"
            )}
            &nbsp;
            {schedule.state && (
              <Badge
                count={schedule.state}
                style={{
                  backgroundColor:
                    schedule.state === "active" ? "#52c41a" : "#777",
                }}
              />
            )}
          </h4>

          {isLoadingTest ? (
            <p>
              {this.props.i18n.t("Connection test")} &nbsp;{" "}
              <Icon type="loading" />
            </p>
          ) : test.error || test.status ? (
            <p>
              <Badge
                count={
                  test.error ||
                  `${this.props.i18n.t("Connection")} : ${test.status}`
                }
                style={{ backgroundColor: test.error ? "#f00" : "#52c41a" }}
              />
            </p>
          ) : (
            <div style={{ margin: '0 0 5px' }}>
              <Button size="small" type="primary" onClick={() => { this.getStatus(); }}>
                Test API connection
              </Button>
            </div>
          )}

          {isLoadingData ? (
            <Icon type="loading" />
          ) : (
            <div>
              <Row gutter={12}>
                <Col span={12}>
                  <label>
                    <b>URL</b>
                    <Form.Item>
                      {getFieldDecorator("url", {
                        initialValue: schedule.url,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>

                <Col span={12}>
                  <label style={{ display: "block", width: "170px" }}>
                    <b>
                      {this.props.i18n.t(
                        "NamespaceScheduleUpload1Form:Minutes delay"
                      )}
                    </b>
                    <Form.Item>
                      {getFieldDecorator("minutes_time", {
                        initialValue: schedule.minutes_time,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("Imednet API key")}</b>
                    <Form.Item>
                      {getFieldDecorator("imednet_api_key", {
                        initialValue: schedule.imednet_api_key,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input.Password />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("Imednet security key")}</b>
                    <Form.Item>
                      {getFieldDecorator("imednet_security_key", {
                        initialValue: schedule.imednet_security_key,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input.Password />)}
                    </Form.Item>
                  </label>
                </Col>
                <Col span={12}>
                  <label>
                    <b>{this.props.i18n.t("Imednet study key")}</b>
                    <Form.Item>
                      {getFieldDecorator("imednet_study_key", {
                        initialValue: schedule.imednet_study_key,
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input />)}
                    </Form.Item>
                  </label>
                </Col>

                {/*<Col span={12}>
                  <label style={{ display: 'block', width: '170px' }}>
                    <b>Time Zone:</b>
                    <Form.Item>
                      {getFieldDecorator('time_zone', {
                        initialValue: get(schedule, 'time_zone', '')
                      })(
                        <Select showSearch placeholder='Select' onChange={this.onChangeTimezone}>
                          <Option value="">None</Option>
                          {timezones.map(({ utc }) => utc.map((tz, i) => (
                            <Option value={tz} key={i}>{tz}</Option>
                          )))}
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>*/}
              </Row>

              {requestResult.type && (
                <Alert
                  message={requestResult.message}
                  type={requestResult.type}
                  className={classes.submitResult}
                />
              )}

              <div className={classes.actionWrapper}>
                {apiImednetCreatePermission && (
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      className={classes.submitButton}
                    >
                      {this.props.i18n.t("Save")}
                      {isLoading && <Icon type="loading" />}
                    </Button>
                    &nbsp; &nbsp;
                  </Form.Item>
                )}

                <Button
                  type="default"
                  size="large"
                  htmlType="button"
                  className={classes.submitButton}
                  onClick={this.props.onCancel}
                >
                  {this.props.i18n.t("Cancel")}
                </Button>

                {((apiImednetDeletePermission && schedule.state === "active") ||
                  (apiImednetUpdatePermission &&
                    schedule.state !== "active")) && (
                  <div className={classes.activateWrap}>
                    {this.props.i18n.t("Activate")} &nbsp;
                    <Switch
                      disabled={isLoading}
                      className={classes.activateBtn}
                      checked={schedule.state === "active"}
                      onChange={this.onSwitchActivation(schedule.state)}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  apiImednetCreatePermission: getApiImednetCreatePermission(state),
  apiImednetUpdatePermission: getApiImednetUpdatePermission(state),
  apiImednetDeletePermission: getApiImednetDeletePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "ImednetScheduleForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ImednetScheduleForm))
);



// WEBPACK FOOTER //
// ./src/components/ImednetScheduleForm/ImednetScheduleForm.js